import { render, staticRenderFns } from "./CrmProspectSelector.vue?vue&type=template&id=527b06f6&scoped=true"
import script from "./CrmProspectSelector.vue?vue&type=script&lang=js"
export * from "./CrmProspectSelector.vue?vue&type=script&lang=js"
import style0 from "./CrmProspectSelector.vue?vue&type=style&index=0&id=527b06f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b06f6",
  null
  
)

export default component.exports